import styled from 'styled-components';

export const TermsPrivacy = styled.div`
  font-weight: 500;
  font-size: 12px;
  line-height: 130%;
  padding: 20px 40px 10px;
`;
